export default {"src":"/_next/static/media/karate.213ebf96.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};